module.exports = __webpack_public_path__ + "img/jovenes-03.c7eb6eca.png";